import "./App.css";
import { App as Canvas } from "./Canvas";
import { Overlay } from "./Overlay";

function App() {
  return (
    <>
      <Canvas></Canvas>
      <Overlay />
    </>
  );
}

export default App;
